import React from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const BreadcrumbsComponent = ({
  title,
  subTitle,
  subTitleRoute,
  formTitle,
  showFormTitle = true,
}) => {
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ color: "white", marginTop: { xs: "8px", md: "0" } }}
    >
      <Typography
        sx={{
          color: "#ffffff99",
          fontSize: { xs: "0.75rem", md: "1rem" },
        }}
      >
        {title}
      </Typography>
      <Typography
        component={RouterLink}
        to={subTitleRoute}
        sx={{
          color: showFormTitle ? "#ffffff" : "#ffffff99",
          textDecoration: "none",
          fontSize: { xs: "0.75rem", md: "1rem" },
        }}
      >
        {subTitle}
      </Typography>
    </Breadcrumbs>
  );
};

export default BreadcrumbsComponent;
